export type CouponData = PercentageCouponData | FixedAmountCouponData;

export interface Coupon {
    data: CouponData;
    id: number;
    menuId: number;
    organizationBranchId: number;
    organizationId: number;
}

export enum CouponType {
    percentage = 'Percentage',
    fixedAmount = 'FixedAmount',
    all = 'All',
}

export interface PercentageCouponData{
    code: string;
    discountPercent: number;
    endDate: Date;
    startDate: Date;
    totalUsagesLimit: number;
    type: CouponType.percentage;
}

export interface AmountInCurrency {
    amount: number;
    currencyId: string;
}

export interface FixedAmountCouponData{
    code: string;
    discountAmount: AmountInCurrency;
    endDate: Date;
    startDate: Date;
    totalUsagesLimit: number;
    type: CouponType.fixedAmount;
}








